import { prop, switchProp } from 'styled-tools'
import styled, { css } from 'styled-components'
import { color, ColorProps, typography, TypographyProps } from 'styled-system'

export type PriceStylesProps = ColorProps &
  TypographyProps & {
    variant?: 'currency' | 'decimal' | 'fraction'
  }

export const Coin = styled.span<PriceStylesProps>`
  ${color}
  ${typography}

  ${switchProp(prop('variant'), {
    currency: css`
      ${color}
      ${typography}
    `,
    decimal: css`
      ${color}
      ${typography}
    `,
    fraction: css`
      ${color}
      ${typography}
    `,
  })}
`

export const Container = styled.span`
  /* display: flex;
  flex-direction: row; */
`
